import couseSample1 from '../assets/course-sample1.png';
import couseSample2 from '../assets/course-sample2.png';
import couseSample3 from '../assets/course-sample3.png';
import couseSample4 from '../assets/course-sample4.png';
import couseSample5 from '../assets/course-sample5.png';

export const jobsExample = [
  {
    name: 'Jovem Aprendiz Business',
    company: 'Wood Wood',
    shortDescription: 'Capacidade de fazer propostas e/ou agir por iniciativa própria',
    description: `Capacidade de fazer propostas e/ou agir por iniciativa própria, antecipando-se aos potenciais problemas e/ou oportunidades.
    Apropiar-se das necessidades dos clientes, gerando soluções assertivas com garantia de qualidade e cumprimento dos prazos."
    Priorizar a satisfação das necessidades dos clientes (partes envolvidas), buscando e implementando soluções adequadas, visando a resultados efetivos.
    Apresentar propostas criativas, desenvolvendo novas idéias e buscando a melhoria contínua das práticas aplicadas.
    Capacidade de estar comprometido com os objetivos da organização, assumindo e mantendo compromissos com a Empresa e com a equipe, planejando e disseminando as estratégias da Organização.`,
    time: '08:00 as 12:00',
    city: 'Curitiba - PR',
  },
  {
    name: 'Jovem Aprendiz Business',
    company: 'Wood Wood',
    shortDescription: 'Capacidade de fazer propostas e/ou agir por iniciativa própria',
    description: `Capacidade de fazer propostas e/ou agir por iniciativa própria, antecipando-se aos potenciais problemas e/ou oportunidades.
    Apropiar-se das necessidades dos clientes, gerando soluções assertivas com garantia de qualidade e cumprimento dos prazos."
    Priorizar a satisfação das necessidades dos clientes (partes envolvidas), buscando e implementando soluções adequadas, visando a resultados efetivos.
    Apresentar propostas criativas, desenvolvendo novas idéias e buscando a melhoria contínua das práticas aplicadas.
    Capacidade de estar comprometido com os objetivos da organização, assumindo e mantendo compromissos com a Empresa e com a equipe, planejando e disseminando as estratégias da Organização.`,
    time: '08:00 as 12:00',
    city: 'Curitiba - PR',
  },
  {
    name: 'Jovem Aprendiz Business',
    company: 'Wood Wood',
    shortDescription: 'Capacidade de fazer propostas e/ou agir por iniciativa própria',
    description: `Capacidade de fazer propostas e/ou agir por iniciativa própria, antecipando-se aos potenciais problemas e/ou oportunidades.
    Apropiar-se das necessidades dos clientes, gerando soluções assertivas com garantia de qualidade e cumprimento dos prazos."
    Priorizar a satisfação das necessidades dos clientes (partes envolvidas), buscando e implementando soluções adequadas, visando a resultados efetivos.
    Apresentar propostas criativas, desenvolvendo novas idéias e buscando a melhoria contínua das práticas aplicadas.
    Capacidade de estar comprometido com os objetivos da organização, assumindo e mantendo compromissos com a Empresa e com a equipe, planejando e disseminando as estratégias da Organização.`,
    time: '08:00 as 12:00',
    city: 'Curitiba - PR',
  },
  {
    name: 'Jovem Aprendiz Business',
    company: 'Wood Wood',
    shortDescription: 'Capacidade de fazer propostas e/ou agir por iniciativa própria',
    description: `Capacidade de fazer propostas e/ou agir por iniciativa própria, antecipando-se aos potenciais problemas e/ou oportunidades.
    Apropiar-se das necessidades dos clientes, gerando soluções assertivas com garantia de qualidade e cumprimento dos prazos."
    Priorizar a satisfação das necessidades dos clientes (partes envolvidas), buscando e implementando soluções adequadas, visando a resultados efetivos.
    Apresentar propostas criativas, desenvolvendo novas idéias e buscando a melhoria contínua das práticas aplicadas.
    Capacidade de estar comprometido com os objetivos da organização, assumindo e mantendo compromissos com a Empresa e com a equipe, planejando e disseminando as estratégias da Organização.`,
    time: '08:00 as 12:00',
    city: 'Curitiba - PR',
  },
];

export const sampleUserData = {
  name: 'Lucas',
  role: 'Jovem Aprendiz',
  mentorships: [
    {
      id: 1,
      name: 'Teste Vocacional',
      date: '17/01/21 - 19:30',
      link: 'https://meet.google.com/rit-wxno-iad',
    },
    {
      id: 3,
      name: 'Acompanhamento Pessoal',
      date: '10/02/21 - 15:00',
      link: 'https://meet.google.com/new',
    },
    {
      id: 4,
      name: 'Acompanhamento Acadêmico',
      date: '17/02/21 - 21:00',
      link: 'https://meet.google.com/new',
    },
    {
      id: 5,
      name: 'Acompanhamento Técnico',
      date: '28/02/21 - 08:00',
      link: 'https://meet.google.com/new',
    },
    {
      id: 6,
      name: 'Coleta de Feedbacks',
      date: '12/03/21 - 15:00',
      link: 'https://meet.google.com/new',
    },
  ],
  courses: [
    {
      image: couseSample1,
      progress: '70%',
    },
    {
      image: couseSample2,
      progress: '60%',
    },
    {
      image: couseSample3,
      progress: '10%',
    },
    {
      image: couseSample4,
      progress: '0%',
    },
    {
      image: couseSample5,
      progress: '29%',
    },
  ],
}

export const sampleFunctionData = {
  aboutCompany: 'O Grupo CCR, antiga Companhia de Concessões Rodoviárias, é uma empresa brasileira de concessão de infraestrutura, transportes e serviços, uma das líderes na administração de rodovias no Brasil, com um total de 3,955 km administrados e faz parte dos mais importantes índices do mercado acionário brasileiro.',
  employeeFunction: 'Sua missão será aprender e colocar em prática as rotinas de suporte aos times da CCR.',
  employeeResponsibilities: [
    'Auxiliar nas rotinas dos departamentos administrativos',
    'Acompanhamento de relatórios',
    'Elaborações de planilhas',
    'Controle de arquivos',
  ],
}

export const sampleAvailableTimes = [
  '09:00',
  '13:30',
  '15:30',
  '17:00',
  '18:30',
  '21:00',
]